import { createContext, useContext, useMemo, useState } from "react";

export const EasyAddContext = createContext();

export const EasyAddProvider = ({ children }) => {
  const [templates, setTemplates] = useState([]);
  const [proxys, setProxys] = useState([]);

  const contextValue = useMemo(
    () => ({
      templates,
      setTemplates,
      proxys,
      setProxys,
    }),
    [templates, proxys],
  );

  return (
    <EasyAddContext.Provider value={contextValue}>
      {children}
    </EasyAddContext.Provider>
  );
};

export const useEasyAdd = () => {
  const context = useContext(EasyAddContext);
  if (!context) {
    throw new Error("useEasyAdd deve ser usado dentro de um <EasyAddProvider>");
  }
  return context;
};
